import React, { useEffect, useState } from 'react';
import { SearchIconGray, ClearSearchIcon } from 'components/Icons';
import API from '../../../API';
import { useHistory } from 'react-router-dom';
import notFoundIcon from '../../../images/not-found.svg';
import { QUESTION_SUPPORT, SEARCH_SUPPORT } from '../../../constants/routes';
import NotifyModal from '../../../components/NotifyModal';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const HelpSearch = props => {
  const { t } = useTranslation();
  const history = useHistory();

  const [response, setResponse] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchValue, setSearchValue] = useState(props.location.state[props.location.state.length - 1]);
  const getHelpInner = id => {
    return API.get(`/faq/${id}`, {})
      .then(resp => {
        if (resp) {
          history.push({ pathname: QUESTION_SUPPORT, state: resp });
        }
      })
      .catch(err => {});
  };
  const handleSearch = query => {
    if (searchValue === '') {
      return;
    } else {
      query = searchValue;
      setLoading(true);

      return API.post('faq/search', { query })
        .then(resp => {
          let { data } = resp;
          setLoading(false);
          if (resp) {
            resp.push(query);
            history.push({ pathname: SEARCH_SUPPORT, state: resp });
          }
        })
        .catch(err => {});
    }
  };
  useEffect(() => {}, []);

  return (
    <div className="text-style help-inner-page-wrapper col-12 col-md-6">
      <div style={{ width: '100%', marginBottom: '28px' }} className="support-search-header">
        <input
          onKeyDown={evt => {
            if (evt.key === 'Enter') {
              handleSearch(evt.target.value);
            }
          }}
          onChange={evt => setSearchValue(evt.target.value)}
          type="text"
          value={searchValue}
          placeholder="Find answers"
        />
        <button
          className="search-btn"
          onClick={evt => {
            handleSearch(evt.target.value);
          }}
        >
          <SearchIconGray />
        </button>
      </div>

      {props.location.state && (
        <p className="search-result">Search result for "{props.location.state[props.location.state.length - 1]}"</p>
      )}
      {props.location.state.length <= 1 && <p className="not-found search-result">Not found</p>}

      <div className="search-wrapper">
        {props.location.state.map(item => {
          return (
            <>
              {!item[item.length - 1] && (
                <div>
                  <h3 className="cursor-pointer" onClick={() => getHelpInner(item.id)}>
                    {item.title}
                  </h3>
                  <div>
                    <p className="text-style help-inner-page-wrapper--content">{item.body}</p>
                  </div>

                  <hr />
                </div>
              )}
            </>
          );
        })}
      </div>
    </div>
  );
};

export default HelpSearch;
